import DataWrapper from "./DataWrapper";

export default class PagedDataWrapper extends DataWrapper{
    constructor({
                    //attributes
                    data= [],
                    current_page= 0,
                    from= 0,
                    last_page= 0,
                    per_page= 0,
                    to= 0,
                    total= 0,
                } = {}) {
        super(data);

        //fill attributes
        this.current_page=current_page;
        this.from=from;
        this.last_page=last_page;
        this.per_page=per_page;
        this.to=to;
        this.total=total;

    }

    concatPage(pagedData){
        this.data = this.data.concat(pagedData.data)
        this.current_page = pagedData.current_page
        this.to = pagedData.to
    }

    isFirstPage(){
        return this.current_page === 1;
    }

    isPaginated() {
        return true;
    }

    updateData(data) {
        if(data instanceof PagedDataWrapper && !data.isFirstPage()){ //check if is new query or next page
            this.concatPage(data);
            return this;
        }else{
            return data;
        }
    }

    getNextPage(){
        return this.current_page+1;
    }

    isLastPage(){
        return this.current_page>=this.last_page;
    }
}